var map = {
	"./account-balance.svg": [
		9539,
		9539
	],
	"./add-person.svg": [
		3015,
		3015
	],
	"./addDocument.svg": [
		3018,
		3018
	],
	"./arrow-down.svg": [
		5062,
		5062
	],
	"./arrow-left.svg": [
		7045,
		7045
	],
	"./arrow-right.svg": [
		9973,
		9973
	],
	"./bill.svg": [
		7670,
		7670
	],
	"./boleto.svg": [
		8783,
		8783
	],
	"./calendar.svg": [
		539,
		539
	],
	"./card.svg": [
		2625,
		2625
	],
	"./check-circle.svg": [
		3414,
		3414
	],
	"./clipboard.svg": [
		2030,
		2030
	],
	"./credit-card.svg": [
		3937,
		3937
	],
	"./document.svg": [
		1017,
		1017
	],
	"./dollar.svg": [
		4597,
		4597
	],
	"./download.svg": [
		790,
		790
	],
	"./edit.svg": [
		7874,
		7874
	],
	"./email.svg": [
		6457,
		6457
	],
	"./error.svg": [
		3428,
		3428
	],
	"./export.svg": [
		4759,
		4759
	],
	"./external-link.svg": [
		3933,
		3933
	],
	"./file-download.svg": [
		2804,
		2804
	],
	"./filter.svg": [
		9533,
		9533
	],
	"./finance.svg": [
		1016,
		1016
	],
	"./grupo.svg": [
		8211,
		5517
	],
	"./home.svg": [
		8635,
		8635
	],
	"./instagram.svg": [
		1553,
		1553
	],
	"./link.svg": [
		8301,
		6973
	],
	"./linkedin-rect.svg": [
		8360,
		8360
	],
	"./list.svg": [
		7254,
		7254
	],
	"./location.svg": [
		6246,
		6246
	],
	"./md-card.svg": [
		1556,
		1556
	],
	"./meal.svg": [
		1101,
		1101
	],
	"./ok.svg": [
		523,
		523
	],
	"./options-outline-svgrepo-com.svg": [
		6535,
		6194
	],
	"./people-fill.svg": [
		3166,
		3166
	],
	"./plus-circle.svg": [
		2471,
		2471
	],
	"./power.svg": [
		9435,
		9435
	],
	"./qr-code.svg": [
		7937,
		7937
	],
	"./receipt.svg": [
		5254,
		5254
	],
	"./recharge.svg": [
		4456,
		4456
	],
	"./repeat.svg": [
		5850,
		5850
	],
	"./request-list.svg": [
		614,
		614
	],
	"./search.svg": [
		151,
		151
	],
	"./shopping-cart.svg": [
		5696,
		184
	],
	"./slash.svg": [
		7616,
		7616
	],
	"./team.svg": [
		913,
		913
	],
	"./telephone-fill.svg": [
		8655,
		8655
	],
	"./transport.svg": [
		3332,
		3332
	],
	"./trash-2.svg": [
		3189,
		3189
	],
	"./trash.svg": [
		5932,
		5932
	],
	"./triangle.svg": [
		6477,
		6477
	],
	"./twitter-bird.svg": [
		2667,
		2667
	],
	"./upload.svg": [
		8334,
		8334
	],
	"./user-settings.svg": [
		4909,
		4909
	],
	"./warning.svg": [
		9238,
		2526
	],
	"./x.svg": [
		1153,
		1153
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 865;
module.exports = webpackAsyncContext;